import _ from "lodash";
import {
  Arr
} from '../../../lib/Array.lib';
import Candidate from "../../../lib/Candidate";
import updateCandidateManually from '../../../lib/Candidate/updateCandidateManually.async';
import CandidateSkillsAction from "../../../lib/CandidateSkillsAction";
import Core from "../../../lib/Core";
import Engagement from "../../../lib/Engagement";
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import FilterControl from "../../../lib/FilterControl";
import Job from "../../../lib/Job";
import {
  getPersonName,
  Obj
} from '../../../lib/Object.lib';
import FilterLib from "../../../lib/services/Filtering/Filter.lib";
import { Str } from '../../../lib/String.lib';
import formatMoney from "../../../lib/tools/formatMoney";
import {
  YearsOfExperienceColor
} from "../../../lib/YearOfExperienceColor";
import mapCandidateSignalsOnChange from '../../Candidates/mapCandidateSignalsOnChange.tool';
import Button from '../../Layout/Wrappers/Button';
import Chip from '../../Layout/Wrappers/Chip';
import Dialog from '../../Layout/Wrappers/Dialog';
import Fieldset from '../../Layout/Wrappers/Fieldset';
import InputNumber from '../../Layout/Wrappers/InputNumber';
import Slider from "../../Layout/Wrappers/Slider";
import CandidatePipe from "../Candidate/CandidatePipe";
import {
  NewFilterControl__state
} from '../FilterControl/NewFilterControl';
import {
  unitTestingPresetLocationMenusAll
} from "../Libraries/Match.lib";
import {
  getMatchEntities
} from '../Libraries/MatchList.lib';
import SingleCandidateCard from "../List/SingleCandidateCard";
import {
  VALUE__MATCH__RANGE_EXPERIENCE__MAXIMUM,
  VALUE__MATCH__RANGE_EXPERIENCE__MINIMUM
} from '../MatchPage';
import JobPipe from "./JobPipe";

let job = {};
let allMatches = [];

const fetchProfile = (jobId) => (cb) => {
  Job.get(jobId, (result) => {
    job = Obj(result);
    Engagement.getWhere({ jobId: job.id }, (engagement) => {
      job["tempSalaryMin"] = job.salaryMax;
      //April doesn't want it anymore as we have loose match buffer available
      // j['tempMinimumSalary'] = j.salaryMax*1.4;
      job["tempMinimumSalary"] = job.salaryMax;
      job["rangeExperience"] = [
        job.minYearsOfExperience,
        VALUE__MATCH__RANGE_EXPERIENCE__MAXIMUM
      ];
      !!cb && cb(job, engagement);
    }, {}, { source: `job__match__strategy__fetch_profile` });
  });
};

const fetchMatches = (params) => (cb, paramsExtra = {}) => {
  if (params.loadAll) {
    Candidate.getAll((candidates) => {
      allMatches = candidates;
      !!cb && cb(candidates);
    });
  }
  else {

    /* FILTERING FIELD FROM DB!! */
    const filters = {
      fields: [
        "id",
        "firstName",
        "lastName",
        "yearsOfExperience",
        "minimumSalary",
        "workLocationIds",
        "visa",
        "platformRating",
        "technicalSkills",
        "stage",
        "state",
        "roles",
        "introduced",
        "accountId",
        "jobsPermitted",
        "jobsPitched",
        "jobsDeclined",
        "isDuplicate",
        "techSkillsInResume",
        "officeLocations",
        "desiredEmploymentTypes",
        "candidateLocations",
        "inOfficeRemoteFlags",
        "matchExclusions",
        "updatedAt",
        "positiveSignals",
        "negativeSignals",
      ],
      include: [{
        relation: "engagements",
        scope: {
          fields: ['id', 'jobId']
        }
      }]
    };
    const { dateRange } = NewFilterControl__state();
    Candidate.getActiveCandidates(
      (candidates) => {
        allMatches = candidates;
        !!cb && cb(candidates);
      },
      {
        key: 'Match__Job__Strategy__fetchMatches',
        dateRange,
        includeStarredCandidates: false,
        filters
      }
    );
  }
};

const getDefaultFields = (job) => {
  return [
    { key: "visa", label: job._visaTransfer, checked: true },
    { key: "locationCandidate", label: job._locations, checked: true },
    { key: "stage", label: job._employeeStage, checked: false },
  ];
};

/** 
 * [2024-07-03][story_9166] 
 * @todo  Rename "object" param.
 * @todo  Why this strategy method doesn't use param "selected", opposed to Candidate?
 */
const filterControl = ({
  profile, // JOB
  object // LIST OF CANDIDATES
}) => {

  let preset = "^Active$";
  if (profile._roles && profile._roles.length) {
    preset += ("|^" + profile._roles.replace(/, |,/g, "$|^") + "$");
  }

  /**
   * If it is Job._jobType defined
   * then preset it to filter Candidates by
   * Candidate._desiredEmploymentTypes
   * story-3083-M1-1
   */
  if (profile._jobType && !!profile._jobType.length) {
    preset += `|^${profile._jobType.trim().replace(/\(|\)/g, ".+")}$`;
  }

  const label = getDefaultFields(profile);
  const fields = label;

  const filters = FilterControl.setInitialSearchMenu(
    object,
    _.cloneDeep(Candidate.getMenus()),
    _.cloneDeep(Candidate.more),
    preset,
    profile,
    [],
    label,
    fields,
    getChips,
    { job: profile }
  );

  const { menus, more, sources, chips } = filters;

  const filteredMatches = filterCandidates(profile, object, [], menus, more);

  return {
    menus,
    more,
    sources,
    chips,
    filteredMatches,
    constraintsObjects: [],
    withoutConstraintsObjects: object,
  };
};

const skillsHandler = (candidate, cbUpdateCandidates) => async (skills, type) => {
  let oldSkills;
  let oldCandidateState;
  let oldCandidateStateIndex;
  let withoutThisCandidate;
  let updateOldCandidateState;
  let updatedCandidate;

  switch (type) {
    case "technicalSkills":
      oldSkills = candidate.technicalSkills;

      oldCandidateState =
        allMatches.find((c) => c.id === candidate.id) || candidate;
      oldCandidateStateIndex = allMatches.findIndex(
        (c) => c.id === candidate.id
      );
      withoutThisCandidate = allMatches.filter((c) => c.id !== candidate.id);

      updateOldCandidateState = {
        ...oldCandidateState,
        technicalSkills: skills,
      };

      updatedCandidate = [...withoutThisCandidate];

      updatedCandidate.splice(
        oldCandidateStateIndex,
        0,
        updateOldCandidateState
      );
      allMatches = [...updatedCandidate];

      !!cbUpdateCandidates && cbUpdateCandidates(allMatches);
      updateCandidateManually({
        id: candidate.id,
        update: {
          technicalSkills: skills,
        },
        key: "Match__Job__Strategy__skillsHandler__technicalSkills",
      }).then(
        (response) => {
          const dirtyAttrs = [
            {
              key: type,
              label: "Technical Skills",
              oldState: oldSkills,
              newState: skills,
            },
          ];
          CandidateSkillsAction.processUpdate(candidate, dirtyAttrs);
          Core.showSuccess("Saved Successfully!");
        }
      ).catch(globalErrorHandler);
      break;
    case "technologyDomain":
      oldSkills = candidate.technologyDomain;

      oldCandidateState =
        allMatches.find((c) => c.id === candidate.id) || candidate;
      oldCandidateStateIndex = allMatches.findIndex(
        (c) => c.id === candidate.id
      );
      withoutThisCandidate = allMatches.filter((c) => c.id !== candidate.id);

      updateOldCandidateState = {
        ...oldCandidateState,
        technologyDomain: skills,
      };

      updatedCandidate = [...withoutThisCandidate];

      updatedCandidate.splice(
        oldCandidateStateIndex,
        0,
        updateOldCandidateState
      );

      allMatches = [...updatedCandidate];

      !!cbUpdateCandidates && cbUpdateCandidates(allMatches);
      updateCandidateManually({
        id: candidate.id,
        update: {
          technologyDomain: skills,
        },
        key: "Match__Job__Strategy__skillsHandler__technologyDomain",
      }).then(
        (response) => {
          const dirtyAttrs = [
            {
              key: type,
              label: "Technology Domain",
              oldState: oldSkills,
              newState: skills,
            },
          ];
          CandidateSkillsAction.processUpdate(candidate, dirtyAttrs);
          Core.showSuccess("Saved Successfully!");
        }
      ).catch(globalErrorHandler);
      break;
    case "positiveSignals":
      oldSkills = [...candidate.positiveSignals];
      oldCandidateState = allMatches.find((c) => c.id === candidate.id) || candidate;
      await mapCandidateSignalsOnChange({
        candidate,
        signals: skills,
        key: 'positiveSignals',
        updater: update => {
          updateOldCandidateState = Object.assign(oldCandidateState, update);
          updateCandidateManually({
            id: candidate.id,
            update,
            key: "Match__Job__Strategy__skillsHandler__positiveSignals",
          }).then(
            (response) => {
              const dirtyAttrs = [
                {
                  key: type,
                  label: "Positive Signals",
                  oldState: oldSkills,
                  newState: update.positiveSignals,
                },
              ];
              CandidateSkillsAction.processUpdate(candidate, dirtyAttrs);
              Core.showSuccess("Saved Successfully!");
            }
          ).catch(globalErrorHandler);
        }
      });
      break;
    case "negativeSignals":
      oldSkills = [...candidate.negativeSignals];
      oldCandidateState = allMatches.find((c) => c.id === candidate.id) || candidate;
      await mapCandidateSignalsOnChange({
        candidate,
        signals: skills,
        key: 'negativeSignals',
        updater: update => {
          updateOldCandidateState = Object.assign(oldCandidateState, update);
          updateCandidateManually({
            id: candidate.id,
            update,
            key: "Match__Job__Strategy__skillsHandler__negativeSignals",
          }).then(
            (response) => {
              const dirtyAttrs = [
                {
                  key: type,
                  label: "Negative Signals",
                  oldState: oldSkills,
                  newState: update.negativeSignals,
                },
              ];
              CandidateSkillsAction.processUpdate(candidate, dirtyAttrs);
              Core.showSuccess("Saved Successfully!");
            }
          ).catch(globalErrorHandler);
        }
      });
      break;
    default:
      break;
  }
};

const segregateRolesChip = (candidate = {}, job = {}) => {
  let colorAlarm = "red";

  if (!!candidate.id && !!candidate._roles) {
    candidate._roles.split(",").forEach((roles) => {
      const rolesRegExp = new RegExp(roles.trim(), "gi").test(job._roles);
      if (!!rolesRegExp) colorAlarm = "";
    });

    return candidate._roles.split(",").map((roles) => {
      return staticRowDisplayChip(
        roles,
        job._roles,
        staticRowDisplayColor(roles, job, colorAlarm).getRolesColor()
      );
    });
  }
};

const segregateLocationChip = (candidate, job) => {
  let colorAlarm = "red";

  if (!!candidate.id && !!candidate._workLocationIds) {
    candidate._workLocationIds.split(",").forEach((loc) => {
      const locRegExp = new RegExp(loc.trim(), "gi").test(job._locations);
      if (!!locRegExp) colorAlarm = "";
    });

    return candidate._workLocationIds.split(",").map((loc) => {
      return staticRowDisplayChip(
        loc,
        job._locations,
        staticRowDisplayColor(loc, job, colorAlarm).getLocationColor()
      );
    });
  }
};

const saveContentCandidate = (candidate, callback) => (key, content) => {
  const oldCandidateState = allMatches.find((c) => c.id === candidate.id);
  const oldCandidateStateIndex = allMatches.findIndex(
    (c) => c.id === candidate.id
  );
  const withoutThisCandidate = allMatches.filter(
    (c) => c.id !== candidate.id
  );

  const updateOldCandidateState = {
    ...oldCandidateState,
    [key]: content,
  };

  let updatedCandidate = [...withoutThisCandidate];

  updatedCandidate.splice(oldCandidateStateIndex, 0, updateOldCandidateState);

  allMatches = [...updatedCandidate];

  !!callback && callback(allMatches);

  updateCandidateManually({
    id: candidate.id,
    update: { [key]: content, },
    key: "Match__Job__Strategy__saveContentCandidate",
  }).then(
    () => {
      Core.showSuccess("Saved Successfully!");
    }
  ).catch(globalErrorHandler);

};

const saveJob = (key, content) => {
  job = {
    ...job,
    [key]: content,
  };

  Job.update(
    job.id,
    {
      [key]: content,
    },
    () => {
      Core.showSuccess("Saved Successfully!");
    }
  );
};

const staticRowDisplayChip = (jobAtr, candAtr, color) => {
  const singleAttrJob = !!jobAtr ? jobAtr.toString().split(",") : [];

  if (!jobAtr || !candAtr) {
    return singleAttrJob.map((attr, index) => {
      return (
        <Chip
          key={index}
          className="slim-chip ui-job-match-strategy-chip-a"
          label={attr}
          size="small"
          variant="outlined"
          style={{
            border: `1px solid gray`,
          }}
        />
      );
    });
  }

  return singleAttrJob.map((attr, index) => {
    return (
      <Chip
        key={index}
        className="slim-chip ui-job-match-strategy-chip-b"
        label={attr}
        size="small"
        variant="outlined"
        style={{
          border: `${color === 'red' ? 2 : 1}px solid ${color}`,
        }}
      />
    );
  });
};
const staticRowDisplayColor = (candidate, job, color) => {
  let obj = {};

  obj.getSalaryColor = ((candidate, job) => () => {
    if (!candidate.minimumSalary || !job.salaryMax) {
      return "";
    }

    let color;

    if (candidate.minimumSalary <= job.salaryMax) {
      color = "green";
    } else if (candidate.minimumSalary <= 1.15 * job.salaryMax) {
      color = "grey";
    } else if (candidate.minimumSalary <= 1.4 * job.salaryMax) {
      color = "grey";
    } else {
      color = "red";
    }
    // console.log("salary " + color + " cand sal "+candidate.minimumSalary+ " job sal " + job.salaryMax)
    return color;
  })(candidate, job);

  obj.getVisaColor = ((candidate, job) => () => {
    let menu = Candidate.getMenus().find((obj) => obj.key === "visa");
    let myMappings = menu.mappings[job._visaTransfer] || [];
    return myMappings.includes(candidate._visa) ? "green" : "red";
  })(candidate, job);

  obj.getRolesColor = ((candidateRole, job) => () => {
    const rolesRegExp = new RegExp(candidateRole.trim(), "gi").test(job._roles);
    return !!rolesRegExp ? "green" : color;
  })(candidate, job);

  obj.getLocationColor = ((candidateLocationLabel, job) => () => {
    const locRegExp = new RegExp(candidateLocationLabel.trim(), "gi").test(
      job._locations
    );
    return !!locRegExp ? "green" : color;
  })(candidate, job);

  obj.getYearsXp = ((candidate, job) => () => {
    return YearsOfExperienceColor(job, candidate);
  })(candidate, job);
  return obj;
};

const renderJobPipe = ({ profile, selectedMatch }, callback) => {
  const { candidate, job } = getMatchEntities({ profile, selectedMatch });
  return (
    <JobPipe
      job={job}
      candidate={candidate}
      saveJob={saveJob}
      staticRowDisplayChip={staticRowDisplayChip}
      staticRowDisplayColor={staticRowDisplayColor}
      source="jobMatch"
    />
  );
};

const renderCandidatePipe = ({ profile, selectedMatch }, callback) => {
  const { candidate, job } = getMatchEntities({ profile, selectedMatch });
  return (
    <CandidatePipe
      candidate={candidate}
      job={job}
      skillsHandler={skillsHandler(candidate, callback)}
      saveContentCandidate={saveContentCandidate(
        candidate,
        callback
      )}
      source="jobMatch"
    />
  );
};

const renderListCard = ({
  match = {},
  ...props
}) => {
  return (
    <SingleCandidateCard {...props}
      key={`match_job__render_card__${match.id}`}
      match={match}
      staticRowDisplayChip={staticRowDisplayChip}
      staticRowDisplayColor={staticRowDisplayColor}
      segregateRolesChip={segregateRolesChip}
      segregateLocationChip={segregateLocationChip}
    />
  );
};

const renderEngagementCard = ({
  engagement = {},
  ...props
}) => {
  return (
    <SingleCandidateCard {...props}
      key={`match_job__render_card__${engagement.id}`}
      engagement={engagement}
      staticRowDisplayChip={staticRowDisplayChip}
      staticRowDisplayColor={staticRowDisplayColor}
      segregateRolesChip={segregateRolesChip}
      segregateLocationChip={segregateLocationChip}
    />
  );
};

const getChips = (job, menus, more, keywords) => {
  const chips = [];

  menus.forEach((menu) => {
    menu.items &&
      Object.keys(menu.items).forEach(
        (name) => menu.items[name] === true && chips.push({ name, menu: true })
      );
  });

  more.forEach((menu) => {
    menu.items &&
      Object.keys(menu.items).forEach((name) => {
        if (name === "Active") {
          const activeLabel = `${menu.label}:${name}`;
          menu.items[name] === true &&
            chips.push({ name: activeLabel, more: true });
        } else {
          menu.items[name] === true && chips.push({ name, more: true });
        }
      });
  });

  !!keywords.length && keywords.forEach((item) => chips.push(item));

  if (!!job.tempMinimumSalary && job.tempMinimumSalary !== 0) {
    let prefix = "";
    prefix = "Accepts Salary <=";

    chips.push({
      name: `${prefix} $${formatMoney(job.tempMinimumSalary, 0)}`,
      minimumSalary: true,
    });
  }

  if (!!job.maximumSalary && job.maximumSalary !== 500000) {
    chips.push({
      name: `Max Salary: $${formatMoney(job.maximumSalary, 0)}`,
      maximumSalary: true,
    });
  }

  if (Arr(job.rangeExperience)[0] > 0) {
    let prefix = "";
    prefix = `has >= ${job.rangeExperience[0]}y exp`;
    chips.push({
      name: `${prefix}`,
      minimumXp: true,
    });
  }
  if (Arr(job.rangeExperience)[1] > 0) {
    let prefix = "";
    prefix = `has <= ${job.rangeExperience[1]}y exp`;
    chips.push({
      name: `${prefix}`,
      minimumXp: true,
    });
  }

  return chips;
};

const filterCandidates = (job, candidates, keywords, menus, more) => {

  unitTestingPresetLocationMenusAll({ job });

  let filtered = candidates;
  if (!filtered) {
    return [];
  }

  /** FILTER BY MINIMUM AND MAXIMUM SALARY */
  if (job && job.tempMinimumSalary !== 0) {
    filtered = filtered.filter((item) => {
      const candidate = item;
      let salaryGreaterThan = job.tempMinimumSalary;

      if (!!job.applyLooseMatch) {
        //increase salary requirement of given job for highly ranked candidates
        if (+candidate.platformRating === 5) {
          // A+
          salaryGreaterThan = 1.5 * salaryGreaterThan;
        } else if (+candidate.platformRating === 1) {
          // A-Top
          salaryGreaterThan = 1.3 * salaryGreaterThan;
        } else if (+candidate.platformRating === 2) {
          // B-Strong
          salaryGreaterThan = 1.15 * salaryGreaterThan;
        }
      }

      return (
        Number(String(item.minimumSalary || 0).replace(/(\..*)|\D/g, "")) <=
        Number(salaryGreaterThan)
      );
    });
  }

  if (
    (
      +Arr(job.rangeExperience)[0] >
      VALUE__MATCH__RANGE_EXPERIENCE__MINIMUM
    ) ||
    (
      +Arr(job.rangeExperience)[1] <
      VALUE__MATCH__RANGE_EXPERIENCE__MAXIMUM
    )
  ) {
    filtered = filtered.filter((item) => {
      const candidate = item;
      let experienceGreaterThan = job.rangeExperience[0];
      let experienceLessThan = job.rangeExperience[1];

      if (!!job.applyLooseMatch) {
        //reduce years of experience requirement of given job for highly ranked candidates
        if (+candidate.platformRating === 5) {
          // A+
          experienceLessThan = 0.5 * experienceLessThan;
        } else if (+candidate.platformRating === 1) {
          // A-Top
          experienceLessThan = 0.7 * experienceLessThan;
        } else if (+candidate.platformRating === 2) {
          // B-Strong
          experienceLessThan = 0.85 * experienceLessThan;
        }
      }
      const numberOfYearsOfExperience = Number(
        Str(item.yearsOfExperience).replace(/(\..*)|\D/g, "")
      );
      return (
        numberOfYearsOfExperience >= experienceGreaterThan &&
        numberOfYearsOfExperience <= experienceLessThan
      );
    });
  }

  /** FILTER BY KEYWORDS */
  if (!!keywords.length) {
    filtered = filtered.filter((item) => {
      return keywords.every((objKeyword) => {
        return item.___keys___.some((label) =>
          new RegExp(
            String(objKeyword.name)
              .replace("+", "\\+")
              .replace(".", "\\.")
              .replace("#", "\\#")
              .replace("(", "\\(")
              .replace(")", "\\)"),
            "i"
          ).test(label)
        );
      });
    });
  }
  filtered = FilterLib.filterCandidatesByMatchExclusion({
    candidates: filtered
  });
  filtered = FilterLib.filterItemsByCheckedOptionsInFilterBar({
    items: filtered,
    menus,
    more,
  });
  return [...filtered];
};

const candidateOfferSalary = (
  closeEvent,
  applyEvent,
  onChangeEvent,
  salary
) => {
  return (
    <Dialog open
      title='Filter by'
      content={
        <Fieldset
          title={
            <>
              Can Work for Salary less than: &nbsp; ${formatMoney(salary, 0)}
            </>
          }
        >
          <Slider
            name="minimumSalary"
            min={0}
            max={500000}
            step={10000}
            value={salary}
            onChange={(event, salary) => {
              !!onChangeEvent && onChangeEvent(salary);
            }}
          />
        </Fieldset>
      }
      actions={[
        <Button outlined minW120
          label="Cancel"
          onClick={(ev) => closeEvent()}
        />,
        <Button primary minW120
          label="Apply"
          onClick={(ev) => applyEvent(salary)}
        />
      ]}
    />
  );
};

const candidateOfferExperience = (
  closeEvent,
  applyEvent,
  onChangeEvent,
  rangeExperience = [
    VALUE__MATCH__RANGE_EXPERIENCE__MINIMUM,
    VALUE__MATCH__RANGE_EXPERIENCE__MAXIMUM
  ]
) => {
  return (
    <Dialog open
      title='Filter by'
      content={
        <Fieldset row
          title={
            <>
              Candidate has xp between&nbsp;
              {formatMoney(rangeExperience[0], 0)}
              &nbsp;and&nbsp;
              {formatMoney(rangeExperience[1], 0)}
              &nbsp;years
            </>
          }
        >
          <InputNumber
            name="rangeExperienceMin"
            min={VALUE__MATCH__RANGE_EXPERIENCE__MINIMUM}
            max={rangeExperience[1]}
            step={1}
            value={rangeExperience[0]}
            onChange={(rangeExperienceMin) => {
              rangeExperience[0] = rangeExperienceMin;
              !!onChangeEvent && onChangeEvent(rangeExperience);
            }}
            className="mr-2 flex-1"
          />
          <InputNumber
            name="rangeExperienceMax"
            min={rangeExperience[0]}
            max={VALUE__MATCH__RANGE_EXPERIENCE__MAXIMUM}
            step={1}
            value={rangeExperience[1]}
            onChange={(rangeExperienceMax) => {
              rangeExperience[1] = rangeExperienceMax;
              !!onChangeEvent && onChangeEvent(rangeExperience);
            }}
            className="flex-1"
          />
        </Fieldset>
      }
      actions={[
        <Button outlined minW120
          label="Cancel"
          onClick={(ev) => closeEvent()}
        />,
        <Button primary minW120
          label="Apply"
          onClick={(event) => applyEvent(rangeExperience)}
        />
      ]}
      paperStyle={{
        minWidth: sizes.m3
      }}
    />
  );
};

const disEngagementModel = ({
  matchStrength = '',
  candidate = {},
  employer = {},
  job = {},
  engagement = {},
  shouldTag = "",
  shouldNotTag = "",
  whyNoPrivateNote = "",
  whyNeedToReadCV = "",
  whyNoCategories = [],
  whyNoDetails = "",
  reviewed,
}) => {
  return {
    source: "jobMatch",
    annotator: Core.getSessionEmail(),
    matchDecision: matchStrength,
    candidateName: getPersonName(candidate),
    employerName: Obj(employer).name,
    jobName: Obj(job).jobTitle,
    engagementStage: Obj(engagement).stage,
    engagementStatus: Obj(engagement).status,
    matchingUrl: !!candidate.id && !!job.id
      ? Core.getPath(`job/match/${job.id}?selected=${candidate.id}`)
      : '',
    engagementUrl: !!engagement.id
      ? Core.getPath(`engagement/view/${engagement.id}`)
      : '',
    candidateUrl: !!candidate.id
      ? Core.getPath(`candidate/edit/${candidate.id}`)
      : '',
    jobUrl: !!job.id
      ? Core.getPath(`job/edit/${job.id}`)
      : '',
    engagementId: engagement.id,
    jobId: job.id,
    candidateId: candidate.id,
    jobRoles: job._roles,
    reviewed,
    shouldTag,
    whyNoDetails,
    whyNoCategories,
    shouldNotTag,
    whyNoPrivateNote,
    whyNeedToReadCV,
  };
};

export default function StrategyMain(id, param) {
  return {
    fetchProfile: fetchProfile(id),
    fetchMatches: fetchMatches(param),
    renderProfilePipe: renderJobPipe,
    renderMatchPipe: renderCandidatePipe,
    renderListCard,
    renderEngagementCard,
    filterControl,
    filterMatches: filterCandidates,
    salaryPopup: candidateOfferSalary,
    experiencePopup: candidateOfferExperience,
    getChips: getChips,
    disEngagementModel,
    matchKey: "candidate",
  };
};
